import { RoleEnum } from '../../slices/services/api'

export const AllAssignedStoresNotAvailableRoles: RoleEnum[] = [
  RoleEnum.AdminStoreManager,
  RoleEnum.EditorStoreManager,
  RoleEnum.Viewer,
]
